import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../common/Layout';
import { Formik } from 'formik';
import UserGroupForm from './UserGroupForm';
import RouterPropsWrapper from '../../common/RouterPropsWrapper';
import LoadingAnimation from '../../common/components/base/LoadingAnimation';
import { validateUserGroup } from '../Validations';
// import { UPDATE_USER_GROUP, GET_USER_GROUP } from "./queries"; // TODO: Both replaced with REST hooks
import { useChallengeNames } from '../../hooks/useChallengeNames';
import { useUpdateUserGroups } from '../../hooks/useUpdateUserGroups';
import { useUserGroup } from '../../hooks/useUserGroup';
import { useUserGroupTeams } from '../../hooks/useUserGroupTeams';
import Swal from 'sweetalert2';
// import { useQuery } from '@apollo/client'; // TODO: Replaced with REST hook
// import { UPDATE_USER_GROUP, GET_USER_GROUP } from "./queries"; // TODO: UPDATE_USER_GROUP replaced with REST hook
// import { useQuery } from '@apollo/client'; // TODO: Replaced with REST hook

// TODO: GET_CHALLENGE_DEFINITION replaced with REST hook useChallengeNames
/*
const GET_CHALLENGE_DEFINITION = gql`
query challengeDefinitions {
  challengeDefinitions{
    id
    challengeName
  }
}
`;
*/

const UserGroupUpdate = (props) => {

  const navigate = useNavigate();
  const [id] = useState(props.match.params.id)
  const { data: userGroupData, isLoading: userGroupLoading, error: userGroupError } = useUserGroup(id);
  const { data: challengesDefinitionsData, isLoading: challengesLoading, error: challengesError } = useChallengeNames('all');
  const { data: userGroupsTeamsData, isLoading: userGroupsTeamsLoading, error: userGroupsTeamsError } = useUserGroupTeams(id);
  
  const updateUserGroupMutation = useUpdateUserGroups();

  if (userGroupLoading || challengesLoading || userGroupsTeamsLoading) return <p><LoadingAnimation /></p>;
  if (userGroupError) return <p>Error :(</p>;
  if (challengesError) return <p>Error :(</p>;
  if (userGroupsTeamsError) return <p>Error: {userGroupsTeamsError.message}</p>;

  // challengesDefinitionsData is now from the REST hook, no need to reassign
  const userGroupsChallenges = (userGroupData.userGroup.groupChallenges.map((item) => challengesDefinitionsData.challengeDefinitionNames.find(( def ) => {  
    return def.id === parseInt(item)
    })))
    return (
      <Layout name="User Group">
        <div class="wizard-container">
          <div class="col-md-8 col-12 mr-auto ml-auto">
            <div class="card card-wizard active" data-color="rose" id="wizardProfile">
                        <Formik
                          initialValues={{ ...userGroupData.userGroup }}
                          validate={validateUserGroup}
                          onSubmit={(values, { setSubmitting }) => {
                            setSubmitting(false);                            
                            const updateData = {
                              name: values.name,
                              groupChallenges: values.groupChallenges,
                              isCareerPath: values.isCareerPath==='true',
                              menu: values.menu 
                            };
                            
                            updateUserGroupMutation.mutate({ 
                              updateData, 
                              id: userGroupData.userGroup._id 
                            }, {
                              onSuccess: () => {
                                Swal.fire({
                                  type: 'success',
                                  title: 'Saved',
                                  showConfirmButton: false,
                                  timer: 1500
                                });
                                navigate('/admin-settings/userGroups');
                              },
                              onError: (error) => {
                                console.error('Error updating user group:', error);
                                Swal.fire({
                                  type: 'error',
                                  text: 'Error assigning challenges to group.',
                                  showConfirmButton: false,
                                  showCancelButton: true,
                                  cancelButtonText: 'Close'
                                });
                              }
                            });
                          }}
                        >
                          {({ isSubmitting, values, handleChange, setFieldValue }) => (
                            <UserGroupForm
                              update='True'
                              handleChangeSize={props.handleChangeSize}
                              handleChangeParent={props.handleChangeParent}
                              isSubmitting={isSubmitting}
                              values={values}
                              teams = {userGroupsTeamsData ? userGroupsTeamsData.teams : [] }
                              userGroupId={id}
                              isCareerPath={values.isCareerPath}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              groupChallenges = {userGroupsChallenges.map((item) => item.id )}
                              groupChallengesSelect={userGroupsChallenges.map((item) => ({ label: item.challengeTitle, value: item.id }))}
                            />
                          )}
                        </Formik>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

export default RouterPropsWrapper(UserGroupUpdate);
